import { ACTIONS, IAppActionInitData } from "app/store/actions"
import { IMediaState } from "media/model"
import { getMediaApprovalData } from "media/repository"
import { Action, Reducer } from "redux"
import {
  IMediaApprovalActionSetFilters,
  IMediaApprovalActionSetIsFilterExpanded,
  IMediaApprovalActionSetList,
  IMediaApprovalActionUpdateMediaApproval
} from "./actions"
import { getDefaultMediaState } from "./state"

export const mediaReducer: Reducer<IMediaState, Action> = (
  state: IMediaState | undefined,
  action: Action
): IMediaState => {
  if (!state) {
    state = getDefaultMediaState()
  }
  switch (action.type) {
    case ACTIONS.APP_INIT_DATA: {
      const { mediaTypes } = action as IAppActionInitData
      return {
        ...state,
        mediaTypes
      }
    }

    case ACTIONS.MEDIA_APPROVAL_START_LOADING: {
      return {
        ...state,
        sspMediaApproval: {
          ...state.sspMediaApproval,
          isLoading: true,
          hasError: false
        }
      }
    }

    case ACTIONS.MEDIA_APPROVAL_HAS_ERROR: {
      return {
        ...state,
        sspMediaApproval: {
          ...state.sspMediaApproval,
          isLoading: false,
          hasError: true,
          mediaApprovalsData: []
        }
      }
    }

    case ACTIONS.MEDIA_APPROVAL_SET_LIST: {
      const { mediaApprovalsData } = action as IMediaApprovalActionSetList
      return {
        ...state,
        sspMediaApproval: {
          ...state.sspMediaApproval,
          mediaApprovalsData,
          filteredMediaApprovalsData: mediaApprovalsData.slice(),
          isLoading: false,
          hasError: false
        }
      }
    }

    case ACTIONS.MEDIA_APPROVAL_SET_FILTERS: {
      const { filters, filteredMediaApprovalsData } = action as IMediaApprovalActionSetFilters
      return {
        ...state,
        sspMediaApproval: {
          ...state.sspMediaApproval,
          filters: { ...state.sspMediaApproval.filters, ...filters },
          filteredMediaApprovalsData
        }
      }
    }

    case ACTIONS.MEDIA_APPROVAL_SET_FILTER_IS_EXPANDED: {
      const { isFilterExpanded } = action as IMediaApprovalActionSetIsFilterExpanded
      return {
        ...state,
        sspMediaApproval: {
          ...state.sspMediaApproval,
          isFilterExpanded
        }
      }
    }

    case ACTIONS.MEDIA_APPROVAL_START_UPDATING: {
      return {
        ...state,
        sspMediaApproval: {
          ...state.sspMediaApproval,
          isUpdating: true
        }
      }
    }

    case ACTIONS.MEDIA_APPROVAL_STOP_UPDATING: {
      return {
        ...state,
        sspMediaApproval: {
          ...state.sspMediaApproval,
          isUpdating: false
        }
      }
    }

    case ACTIONS.MEDIA_APPROVAL_UPDATE: {
      const { mediaApproval } = action as IMediaApprovalActionUpdateMediaApproval
      return {
        ...state,
        sspMediaApproval: {
          ...state.sspMediaApproval,
          mediaApprovalsData: state.sspMediaApproval.mediaApprovalsData.map(m => {
            if (m.media_id === mediaApproval.media_id) {
              return getMediaApprovalData({
                ...m.mediaApprovalsByMedia,
                ssp_approval: m.mediaApprovalsByMedia.ssp_approval.map(a => {
                  if (a.id === mediaApproval.id) {
                    return mediaApproval
                  } else {
                    return a
                  }
                })
              })
            } else {
              return m
            }
          }),
          filteredMediaApprovalsData: state.sspMediaApproval.filteredMediaApprovalsData.map(m => {
            if (m.media_id === mediaApproval.media_id) {
              return getMediaApprovalData({
                ...m.mediaApprovalsByMedia,
                ssp_approval: m.mediaApprovalsByMedia.ssp_approval.map(a => {
                  if (a.id === mediaApproval.id) {
                    return mediaApproval
                  } else {
                    return a
                  }
                })
              })
            } else {
              return m
            }
          }),
          isUpdating: false
        }
      }
    }

    case ACTIONS.USER_LOGOUT: {
      return getDefaultMediaState()
    }

    default:
      return state
  }
}
